





































































































import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import { IHeightStyle } from "@/@types/styles/height";
import { IExcursionCoast } from "@/@types/excursions/excursions";
import { IWorkTimetable } from "@/@types/excursions/excursions";

@Component({})
export default class ExcursionDemo extends Vue {
  @Prop({ type: Number, default: 0 }) currencyType!: number;
  @Prop({ type: String, default: "" }) description!: string;
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, default: "" }) name!: string;
  @Prop({ type: Number, default: 0 }) duration!: number;
  @Prop({ type: Array, default: () => [] }) work_timetable!: IWorkTimetable[];
  @Prop({ type: Array, default: () => [] }) params!: IExcursionCoast[];
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: Boolean, default: false }) included!: boolean;
  @Prop({ type: Boolean, default: false }) awaliblelity!: boolean;

  @Inject({ from: "excursionBgFolder", default: null }) readonly bg!: string;

  number = 0;
  showDemo = false;

  mainHeight: IHeightStyle = {
    minHeight: "auto",
    maxHeight: "auto",
  };

  get productImage(): string | null {
    if (!this.image) return null;
    return this.$getWebImage(this.image, this.bg + "/origin");
  }

  calculateHeight(): void {
    this.mainHeight.maxHeight = sessionStorage.getItem("demo-height") + "px";
    this.mainHeight.minHeight = sessionStorage.getItem("demo-height") + "px";
    this.showDemo = true;
  }

  getTime(ms: number): { days: number; hours: number; minutes: number } {
    const seconds = Math.floor(ms / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    minutes = minutes - hours * 60;
    hours = hours - days * 24;

    return {
      days: days,
      hours: hours,
      minutes: minutes,
    };
  }

  mounted(): void {
    this.calculateHeight();
    window.onresize = () => {
      this.calculateHeight();
    };
  }
}
